"use client";

import { motion } from "framer-motion";
import Header from "@/components/header";
import Footer from "@/components/footer";
import RegistrationStatusCard from "@/components/registration-status-card";
import HelpContactCard from "@/components/help-contact-card";
import { PageTitle } from "@/components/ui/page-header";
import { containerVariants } from "@/lib/animation-variants";

export default function RegistrationTestPage() {
  return (
    <div className="flex min-h-screen flex-col bg-gothia-green">
      <Header />

      <main className="flex-1">
        <section className="px-4 pb-16 pt-8 sm:px-6 lg:px-8">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="mx-auto max-w-4xl">
            <div className="mb-8 text-center">
              <PageTitle title="Anmeldung" />
            </div>

            <motion.div variants={containerVariants} className="space-y-8">
              {/* Status: Kommers & Ball ausverkauft, spontane Programmpunkte */}
              <RegistrationStatusCard />

              {/* Help & Contact */}
              <HelpContactCard />
            </motion.div>
          </motion.div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
